<div class="row">
  <div class="col-md-4"><label>{{title}}</label></div>
  <div class="col-md-8">
    <div class="form-group">

      <input type="password" class="form-control form-control-sm" [placeholder]="title" [(ngModel)]="value" (change)="updateValue($any($event.target).value)">
    </div>
  </div>
</div>
